import { faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { colors } from "../../global";
import { toast } from "react-toastify";

export const AddSlide = ({ slides, addSlide }) => {
  const [newSlideTitle, setNewSlideTitle] = useState(
    `Slide ${slides.length + 1} Title`
  );

  const layoutIcons = {
    1: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="12"
        viewBox="0 0 83 41"
        fill="none"
      >
        <rect width="83" height="41" rx="4" fill="#D9D9D9" />
        <rect x="4" y="4" width="75" height="33" rx="2" fill="#8E8E8E" />
      </svg>
    ),
    2: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="12"
        viewBox="0 0 83 41"
        fill="none"
      >
        <rect width="83" height="41" rx="4" fill="#D9D9D9" />
        <rect x="4" y="4" width="35" height="33" rx="2" fill="#8E8E8E" />
        <rect x="44" y="4" width="35" height="33" rx="2" fill="#8E8E8E" />
      </svg>
    ),
    3: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="12"
        viewBox="0 0 83 41"
        fill="none"
      >
        <rect width="83" height="41" rx="4" fill="#D9D9D9" />
        <rect x="4" y="4" width="75" height="15" rx="2" fill="#8E8E8E" />
        <rect x="4" y="22" width="75" height="15" rx="2" fill="#8E8E8E" />
      </svg>
    ),
    4: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="12"
        viewBox="0 0 83 41"
        fill="none"
      >
        <rect width="83" height="41" rx="4" fill="#D9D9D9" />
        <rect x="4" y="4" width="35" height="15" rx="2" fill="#8E8E8E" />
        <rect x="44" y="4" width="35" height="15" rx="2" fill="#8E8E8E" />
        <rect x="4" y="22" width="35" height="15" rx="2" fill="#8E8E8E" />
        <rect x="44" y="22" width="35" height="15" rx="2" fill="#8E8E8E" />
      </svg>
    ),
    5: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="12"
        viewBox="0 0 83 41"
        fill="none"
      >
        <rect width="83" height="41" rx="4" fill="#D9D9D9" />
        <rect x="4" y="4" width="35" height="15" rx="2" fill="#8E8E8E" />
        <rect x="44" y="4" width="35" height="15" rx="2" fill="#8E8E8E" />
        <rect x="4" y="22" width="75" height="15" rx="2" fill="#8E8E8E" />
      </svg>
    ),
  };

  const handleAddSlide = (layout) => {
    if (!newSlideTitle.trim()) {
      toast.error("Please enter a slide title");
      return;
    }
    addSlide(layout, newSlideTitle.trim());
    setNewSlideTitle("");
  };

  return (
    <div className="mx-auto p-8 rounded-xl border border-gray-300 bg-white shadow-md">
      <div className="w-14 h-14 mx-auto mb-6 flex items-center justify-center rounded-full bg-gray-100 text-gray-500">
        <FontAwesomeIcon icon={faFilePowerpoint} size="lg" />
      </div>

      <p className="text-center text-gray-600 mb-6 text-lg font-semibold">
        Add Another Slide
      </p>

      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mb-6">
        <input
          type="text"
          className="flex-grow font-semibold text-sm bg-gray-50 border border-gray-300 rounded-md px-3 py-2 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
          style={{ color: colors.primary }}
          value={newSlideTitle}
          onChange={(e) => setNewSlideTitle(e.target.value)}
          placeholder={`Slide ${slides.length + 1} Title`}
        />
      </div>

      <div className="flex flex-wrap justify-center gap-3">
        {[1, 2, 3, 4, 5].map((layout) => (
          <button
            key={layout}
            onClick={() => handleAddSlide(layout)}
            className="flex items-center gap-2 px-4 py-2 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-blue-50 hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            type="button"
          >
            <span className="w-6 h-3">{layoutIcons[layout]}</span>
            <span className="text-sm font-medium">Layout {layout}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
